import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAlignVerticalCenter';
/** Renders an SVG icon. */
const SvgAlignVerticalCenter = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7 26a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-9h2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4h3a1 1 0 1 0 0-2h-3v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4h-2V6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v9H4a1 1 0 1 0 0 2h3zm6 0H9V6h4zm10-5h-4V11h4z"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgAlignVerticalCenter.displayName = displayName;
export default SvgAlignVerticalCenter;
